import { Pipe, PipeTransform } from '@angular/core';
import * as changeCase from 'change-case';
import { isString } from 'lodash';

type ChangeCasePipeOptions = 'constantCase' | 'paramCase';

@Pipe({ name: 'changeCase' })
export class ChangeCasePipe implements PipeTransform {
  transform(value: string, option: ChangeCasePipeOptions): string {
    if (!isString(value)) {
      return null;
    }

    return changeCase[option](value);
  }
}
